module.exports = __webpack_public_path__ + "static/img/vipCar.aeabc25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/photo/vipCar.png
// module id = Fsgf
// module chunks = 1